import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';
import GlobalTimer from './GlobalTimer';

const { FiMenu, FiBell, FiLogOut } = FiIcons;

const Header = ({ onMenuClick }) => {
  const { user, logout } = useAuth();

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <motion.button 
            whileHover={{ scale: 1.05 }} 
            whileTap={{ scale: 0.95 }} 
            onClick={onMenuClick} 
            className="p-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-all"
          >
            <SafeIcon icon={FiMenu} className="text-xl" />
          </motion.button>
        </div>

        <div className="flex items-center gap-6">
          <GlobalTimer />
          
          <div className="h-8 w-[1px] bg-slate-100 hidden md:block" />

          <div className="flex items-center space-x-4">
            <motion.button 
              whileHover={{ scale: 1.05 }} 
              whileTap={{ scale: 0.95 }} 
              className="p-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-all relative"
            >
              <SafeIcon icon={FiBell} className="text-xl" />
              <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full"></span>
            </motion.button>

            <div className="flex items-center space-x-3">
              <img src={user?.avatar || 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=100&h=100&fit=crop'} alt={user?.name} className="w-10 h-10 rounded-2xl object-cover border-2 border-white shadow-sm" />
              <div className="hidden md:block">
                <p className="text-sm font-black text-gray-800 tracking-tight">{user?.name}</p>
                <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">{user?.role}</p>
              </div>
            </div>

            <motion.button 
              whileHover={{ scale: 1.05 }} 
              whileTap={{ scale: 0.95 }} 
              onClick={logout} 
              className="p-2 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all"
            >
              <SafeIcon icon={FiLogOut} className="text-xl" />
            </motion.button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;